type FailedFileUpload = {
  file: File;
  error: Error;
};

type SettledFileUploads = {
  /** Files whose upload resolved, in the order they were given. */
  uploaded: File[];
  failed: FailedFileUpload[];
};

/**
 * Uploads every file in parallel, resolving once all have settled. A failure
 * lands in `failed` rather than rejecting the batch and hiding the rest.
 */
export const settleFileUploads = async (
  files: File[],
  uploadFile: (file: File, index: number) => Promise<void>
): Promise<SettledFileUploads> => {
  const results = await Promise.allSettled(
    files.map((file, index) => uploadFile(file, index))
  );

  const uploaded: File[] = [];
  const failed: FailedFileUpload[] = [];
  results.forEach((result, index) => {
    if (result.status === 'fulfilled') {
      uploaded.push(files[index]);
    } else {
      const error =
        result.reason instanceof Error
          ? result.reason
          : new Error(String(result.reason));
      failed.push({ file: files[index], error });
    }
  });

  return { uploaded, failed };
};
